import { apiMipe, api } from '@/core/api/';
export default {
  async getDashboardAlerts(alertTypeId, pageIndex, pageSize) {
    const url = 'api/alert';
    return apiMipe.get(alertTypeId ? `${url}/${alertTypeId}` : url, {
      params: {
        pageIndex,
        pageSize,
      },
    });
  },
  async getDashboardMessages() {
    return await api.get('api/message/mesaggefordashboard');
  },
};
